import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PayeeCasesService } from '../payee-cases.service';
import { products } from '../types';
import { ChipDropdownComponent } from '../chip-dropdown/chip-dropdown.component';
import { PayeeDropdownComponent } from '../../payee-form-fields/payee-dropdown/payee-dropdown.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'payee-case-product-filter',
  templateUrl: './case-product-filter.component.html',
  styleUrls: ['./case-product-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeDropdownComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
    TranslateModule,
  ],
})
export class CaseProductFilterComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private payeeCasesService = inject(PayeeCasesService);

  private readonly destroy = new Subject<void>();
  readonly productControl = new FormControl<string | null>(null);

  dropdownOpen = false;

  readonly productOptions = [...products];

  get product() {
    return this.payeeCasesService.product.value;
  }

  ngOnInit(): void {
    this.payeeCasesService.product
      .pipe(takeUntil(this.destroy))
      .subscribe((v) => this.productControl.patchValue(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  readonly displayWith = (product?: string): string => {
    if (!product) {
      return '';
    }

    return this.translate.instant(
      `CASES_TABLE.FILTERS.PRODUCT.${product.toUpperCase()}`,
    );
  };

  applyFilter(): void {
    this.payeeCasesService.product.next(this.productControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.payeeCasesService.product.next(null);
    this.dropdownOpen = false;
  }
}
